<template>
<div>
    <b-modal id="agentTransactionsReportLawMatterModal" centered size="xl" no-close-on-backdrop ref="agentTransactionsReportLawMatterModal" :title="this.titleText + ' - ' + $t('agentTransactionsReportLawMatter.title')" hide-footer @close="clear()">
        <b-row>
            <b-col class="col-md-12 mb-1 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-right">
                    <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-col>
        </b-row>
        <vue-good-table id="matterTable" ref="matterTable" :columns="filteredColumns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.record_no') }}
                </span>
                <span v-else-if="props.column.field === 'client'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.client') }}
                </span>
                <span v-else-if="props.column.field === 'agent'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.agent') }}
                </span>
                <span v-else-if="props.column.field === 'lawMatterMatterTypeHistoryNames'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.processes') }}
                </span>
                <span v-else-if="props.column.field === 'name'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.name') }}
                </span>
                <span v-else-if="props.column.field === 'operationRecordNo'" class="text-nowrap">
                    {{ $t('agentTransactionsReportLawMatter.stock_ref') }}
                </span>
            </template>
            <!-- Column: Table Column -->
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'lawMatterMatterTypeHistoryList'">
                    <b-col>
                        <b-row v-for="lawMatterMatterTypeHistory in props.row.lawMatterMatterTypeHistoryList" v-bind:data="lawMatterMatterTypeHistory" :key="lawMatterMatterTypeHistory.id" style="font-size: small;">
                            <tr>
                                <span>{{lawMatterMatterTypeHistory.lawMatterTypeName}} </span> <br />
                            </tr>
                        </b-row>
                    </b-col>
                </span>
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}</span>
                        <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
import {
    clear
} from 'echarts/lib/util/throttle';

export default {
    data() {
        return {
            dir: false,
            pageLength: 10,
            total: 0,
            pageNo: 1,
            columns: [{
                    label: this.$t('agentTransactionsReportLawMatter.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('agentTransactionsReportLawMatter.client'),
                    field: `client`,
                },
                {
                    label: this.$t('agentTransactionsReportLawMatter.agent'),
                    field: `agent`,
                },
                {
                    label: this.$t('agentTransactionsReportLawMatter.processes'),
                    field: `lawMatterMatterTypeHistoryList`,
                },
                {
                    label: this.$t('agentTransactionsReportLawMatter.name'),
                    field: `name`,
                },
                {
                    label: this.$t('agentTransactionsReportLawMatter.stock_ref'),
                    field: `operationRecordNo`,
                }
            ],
            rows: [],
            titleText: '',
            clientAccountingId: 0,
            clientId: 0,
        }
    },
    computed: {
        filteredColumns() {
            return this.columns.filter(col => {
                if (col.field === 'agent') {
                    return !(this.clientId == 0 && this.clientAccountingId != 0);
                }
                if (col.field === 'ownerList') {
                    return !(this.clientId > 0 && this.clientAccountingId == 0);
                }
                return true;
            });
        }
    },
    methods: {
        clear() {
            this.rows = []
            this.clientAccountingId = 0
            this.clientId = 0
            this.titleText = ''
        },
        getAgentTransactionsReportList(recordType, clientAccountingId) {
            this.$refs.agentTransactionsReportLawMatterModal.show()
            this.rows = []
            this.clientAccountingId = clientAccountingId
            const data = {
                recordType: recordType,
                clientAccountingId: clientAccountingId
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.titleText = response.data.titleText
                    this.rows = response.data.lawMatterList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        getOwnerTransactionsReportList(recordType, clientId) {
            this.$refs.agentTransactionsReportLawMatterModal.show()
            this.rows = []
            this.clientId = clientId
            const data = {
                recordType: recordType,
                clientId: clientId
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.titleText = response.data.titleText
                    this.rows = response.data.lawMatterList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {
            const controller = {
                name: 'Client',
                actionName: 'CanAgentExcelReport'
            }
            const data = {
                columnList: this.filteredColumns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Tüm İşlemler Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    }

}
</script>

<style>
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
